import { render, staticRenderFns } from "./EliminateTeamsForm.vue?vue&type=template&id=14781894&scoped=true"
import script from "./EliminateTeamsForm.vue?vue&type=script&lang=js"
export * from "./EliminateTeamsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14781894",
  null
  
)

export default component.exports